import { useAppSelector } from '@/redux/core'
import { selectDomain } from '@/redux/app'

const useDomainInfo = () => {
  const domain = useAppSelector(selectDomain)

  return { domain, isFanaticsDomain: domain === 'fanatics' }
}

export default useDomainInfo
